module.exports = __webpack_public_path__ + "static/barra-financiamento-prr-b892e082b66719b7fd58ae171e2ef853.png";